module.exports = __webpack_public_path__ + "static/media/car12.6e75d86e.png";